<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input lazy"
                @submit.prevent="storeRole">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Add New Role</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="formData['title']" autofocus
                                :rules="[vRules.required]"
                                density="compact" label="Title"
                            />
                            <v-select
                                v-model="formData['role_type']"
                                :items="role_types"
                                :loading="loading"
                                :rules="[vRules.required]"
                                density="compact"
                                label="Role Type"
                            />
                            <v-select
                                v-if="formData['role_type'] !== 'api'"
                                v-model="formData['portal_id']"
                                :items="portals"
                                :loading="loading"
                                :clearable="formData['role_type']==='admin'"
                                :rules="formData['role_type'] !== 'admin'?[vRules.required]:[]"
                                density="compact"
                                item-title="name"
                                item-value="id" label="Portal"
                            />
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const portals = ref([]);
const loading = ref(true);
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
});
const formData = reactive({
    valid: false,
    title: null,
    portal_id: null,
    role_type: null,
});
const emits = defineEmits(['update:modelValue', 'addRole']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);
const role_types = [
    {value: 'api', title: 'API'},
    {value: 'admin', title: 'Admin'},
    {value: 'company', title: 'Company'},
];

onMounted(() => {
    fetchPortals();
});

const fetchPortals = () => {
    send('get', `admin/portals`)
        .then((response) => {
            portals.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Portals could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const storeRole = () => {
    errors.value = [];
    send('post', `admin/roles`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('addRole', response.data.data.role);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
